import { useEffect, useState } from 'react';
import axios from 'axios';

const useTiempoRecoleccionTransporte = (
  year, 
  mes, 
  token, 
  idAdministrador,
  provinciaSeleccionada,
  ciudadSeleccionada
) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token || !idAdministrador) {
      setLoading(false);
      return;
    }
    
    setLoading(true);
    
    const fetchData = async () => {
      try {
         
        
        const response = await axios.post(
          'https://seguimientoconductor-nodejs-pits.com/administrador_seginus/obtenerTiempoRecoleccionTransporte',
          { 
            anio: year, 
            mes: mes, 
            id_administrador: idAdministrador,
            provincia: provinciaSeleccionada || null,
            ciudad: ciudadSeleccionada || null
          },
          { headers: { Authorization: token } }
        );
        
        setData(response.data || []);
        setError(null);
      } catch (err) {
         
        setError(err);
        setData([]);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada]);

  return { data, loading, error };
};

export default useTiempoRecoleccionTransporte;